/* DISAYNER · defilement infini, collections et magazine (12/10/2026).

   Remplace assets/infinite-product-grid.js, qui appelait une vue « ajax »
   inexistante, ne s'arretait jamais a la derniere page, vidait la grille a
   chaque changement d'adresse et interrogeait l'adresse toutes les 500 ms.

   Fonctionnement : toute liste <ul data-dsy-infini> declare sa section, sa
   page et son nombre de pages. A l'approche du bas de la liste, la page
   suivante est demandee a Shopify par l'API de rendu de section
   (?page=N&section_id=...), qui ne renvoie que la section. Ses <li> sont
   ajoutes a la liste. On s'arrete a la derniere page. Les filtres de
   collection gardent leurs parametres, puisque l'adresse courante sert de
   base. Quand les filtres remplacent la grille, la nouvelle liste porte ses
   propres valeurs et elle est reprise automatiquement.

   La pagination classique reste dans le HTML pour les moteurs et sans
   JavaScript ; quand le script tourne, elle est remplacee par l'etat du
   chargement et un bouton « Load more ». */
(function () {
  if (window.__dsyInfini) return;
  window.__dsyInfini = true;

  var STYLE =
    '.dsy-infini{display:flex;flex-direction:column;align-items:center;gap:1.4rem;margin:4rem 0 2rem;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;}' +
    '.dsy-infini__etat{margin:0;font-size:1.1rem;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:rgba(255,255,255,.45);min-height:1.4em;}' +
    '.dsy-infini__btn{display:inline-flex;align-items:center;gap:1rem;padding:1.3rem 2.4rem;border:1px solid rgba(255,255,255,.28);border-radius:999px;background:transparent;color:#fff;font:inherit;font-size:1.15rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;cursor:pointer;transition:border-color .15s ease,color .15s ease;}' +
    '.dsy-infini__btn:hover{border-color:#d8ff2e;color:#d8ff2e;}' +
    '.dsy-infini__btn[disabled]{opacity:.35;cursor:default;}' +
    '.dsy-infini.is-charge .dsy-infini__etat::after{content:"";display:inline-block;width:.6em;height:.6em;margin-left:.8em;border-radius:50%;background:#d8ff2e;animation:dsyInfini 1s ease-in-out infinite;vertical-align:middle;}' +
    '@keyframes dsyInfini{0%,100%{opacity:.2}50%{opacity:1}}';

  function injecterStyle() {
    if (document.getElementById('dsy-infini-style')) return;
    var st = document.createElement('style');
    st.id = 'dsy-infini-style';
    st.textContent = STYLE;
    document.head.appendChild(st);
  }

  function nettoyer(html) {
    /* meme traitement que facets.js du theme : sans lui, les cartes ajoutees
       restent invisibles (effet d'apparition) ou gardent leurs gabarits differes */
    try { if (window.appearanceEffect && appearanceEffect.cleanHTMLWithEffect) html = appearanceEffect.cleanHTMLWithEffect(html); } catch (e) {}
    try { if (window.lazyTemplateController && lazyTemplateController.cleanHTMLWithTemplate) html = lazyTemplateController.cleanHTMLWithTemplate(html); } catch (e) {}
    return html;
  }

  function lier(liste) {
    if (liste.__dsyLie) return;
    liste.__dsyLie = true;

    var section = liste.getAttribute('data-section');
    var page = parseInt(liste.getAttribute('data-page') || '1', 10);
    var pages = parseInt(liste.getAttribute('data-pages') || '1', 10);
    var libelles = {
      plus: liste.getAttribute('data-libelle-plus') || 'Load more',
      charge: liste.getAttribute('data-libelle-charge') || 'Loading',
      fin: liste.getAttribute('data-libelle-fin') || ''
    };
    if (!section || pages <= 1 || page >= pages) return;

    injecterStyle();

    /* la pagination de la meme section est remplacee par le bloc d'etat */
    var bloc = document.createElement('div');
    bloc.className = 'dsy-infini';
    bloc.innerHTML = '<p class="dsy-infini__etat" aria-live="polite"></p><button type="button" class="dsy-infini__btn"></button>';
    var etat = bloc.querySelector('.dsy-infini__etat');
    var btn = bloc.querySelector('.dsy-infini__btn');
    btn.textContent = libelles.plus;

    var pagination = document.querySelector('[data-dsy-infini-pagination="' + section + '"]');
    if (pagination && pagination.parentNode) pagination.parentNode.replaceChild(bloc, pagination);
    else liste.parentNode.insertBefore(bloc, liste.nextSibling);

    var occupe = false;
    var observateur = null;

    function terminer() {
      if (observateur) observateur.disconnect();
      btn.remove();
      etat.textContent = libelles.fin;
      bloc.classList.remove('is-charge');
    }

    function charger() {
      if (occupe || page >= pages) return;
      occupe = true;
      bloc.classList.add('is-charge');
      etat.textContent = libelles.charge;
      btn.disabled = true;

      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('page', String(page + 1));
      url.searchParams.set('section_id', section);

      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(nettoyer(html), 'text/html');
          try { if (window.scriptController && scriptController.saveExternalResourcesFromContainer) scriptController.saveExternalResourcesFromContainer(doc); } catch (e) {}
          var recu = doc.querySelector('ul[data-dsy-infini]');
          if (!recu) throw new Error('liste absente');
          var items = Array.prototype.slice.call(recu.children);
          items.forEach(function (li) { liste.appendChild(document.importNode(li, true)); });
          page = page + 1;
          pages = parseInt(recu.getAttribute('data-pages') || String(pages), 10);
          occupe = false;
          bloc.classList.remove('is-charge');
          etat.textContent = '';
          btn.disabled = false;
          if (!items.length || page >= pages) terminer();
          else verifier();
        })
        .catch(function () {
          occupe = false;
          bloc.classList.remove('is-charge');
          etat.textContent = '';
          btn.disabled = false;
        });
    }

    /* si le bloc est deja visible apres un ajout, on enchaine */
    function verifier() {
      var r = bloc.getBoundingClientRect();
      if (r.top < window.innerHeight + 1200) charger();
    }

    btn.addEventListener('click', charger);
    if ('IntersectionObserver' in window) {
      observateur = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) { if (e.isIntersecting) charger(); });
      }, { rootMargin: '0px 0px 1200px 0px' });
      observateur.observe(bloc);
    }
  }

  function chercher() {
    document.querySelectorAll('ul[data-dsy-infini]').forEach(lier);
  }

  /* les filtres de collection remplacent la grille : on reprend la nouvelle liste */
  function surveiller() {
    var racine = document.getElementById('ProductGridContainer') || document.querySelector('[data-dsy-infini]');
    if (!racine || !('MutationObserver' in window)) return;
    var cible = racine.id === 'ProductGridContainer' ? racine : racine.parentNode;
    new MutationObserver(function () {
      var anciens = document.querySelectorAll('.dsy-infini');
      var liste = document.querySelector('ul[data-dsy-infini]');
      if (liste && !liste.__dsyLie) {
        anciens.forEach(function (b) { b.remove(); });
        lier(liste);
      }
    }).observe(cible, { childList: true });
  }

  function demarrer() { chercher(); surveiller(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
